import { Button } from "@/components";
import { ChevronLeft } from "@/icons";

export const BackButton = ({
  text,
  onClick,
}: {
  text: string;
  onClick: () => void;
}) => {
  return (
    <Button
      size="m"
      className="p2-semibold ml-[-4px]" // Make it flush with left aligned content
      variant="tertiary"
      icon={<ChevronLeft className="h-[20px] w-[20px]" />}
      iconPosition="left"
      onClick={onClick}
    >
      {text}
    </Button>
  );
};
